<app-header></app-header>

<div class="myPrograms" *ngIf="!loading">
  <div *ngFor="let program of programData.programs; let i = index">
    <ng-container *ngIf="program?.courses?.length">
      <h2 class="head">{{ program.name.split("program").join("").trim() }}</h2> <span class="headDuration">Duration {{
        program.duration}}mins</span>
      <div class="carousell">
        <div>
          <div class="cards">
            <div class="card" *ngFor="let course of program.courses; let j = index"
              style="box-shadow: 0px 0px 24px rgb(217 217 239 / 20%)">
              <span class="active" *ngIf="course.active === 'Y'"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                  height="16" fill="currentColor" class="bi bi-circle-fill circle" viewBox="0 0 16 16">
                  <circle cx="8" cy="8" r="8" />
                </svg>
                <span class="act">Active</span>
              </span>

              <div class="imh">
                <div class="launchTd" (click)="
                    onClickLaunch(course.courseId, course.courseVer, i, j)
                  ">
                  <span class="launch">
                    {{ course.isCourseEnrolled ? "Launch" : "Enroll" }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="arroww bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                    </svg></span>
                </div>
                <img *ngIf="course.coverImg" class="cardImg" [src]="getImage(course.coverImg)" alt="" />
                <img *ngIf="!course.coverImg" class="cardImg" src="../../assets/images/no_img.png" alt="" />
              </div>
              <div class="cardInfo">
                <div class="name">{{ course.name }}</div>
                <div class="desc">
                  {{ course.descr }}
                </div>
                <div class="infoFlex">
                  <div class="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="icon bi bi-clock" viewBox="0 0 16 16">
                      <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                    </svg>
                    {{ math.round((course.videoduration / 60)) }} Minutes
                  </div>
                  <div class="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="icon bi bi-person" viewBox="0 0 16 16">
                      <path
                        d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                    </svg>
                    {{ course.author }}
                  </div>
                  <div class="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="icon bi bi-calendar" viewBox="0 0 16 16">
                      <path
                        d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                    </svg>
                    {{ course.startDate }}
                  </div>
                  <div class="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="icon bi bi-shield-check" viewBox="0 0 16 16">
                      <path
                        d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                      <path
                        d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                    </svg>
                    Version {{ course.courseVer }}
                  </div>
                </div>

                <div class="complete progress" style="height: 20px">
                  <div role="progressbar" [style.width]="course.progressCompleted + '%'"
                    aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100"
                    [ngClass]="{ pink: course.progressCompleted == 100 }" [ngClass]="{
                      'progress-bar': course.progressCompleted !== 100,
                      green: course.progressCompleted == 100
                    }">
                    <span class="percent">Completed {{ course.progressCompleted }}%</span>
                  </div>
                  <mat-icon *ngIf="course.progressCompleted == 100" [ngClass]="{
                      checkCircle: course.progressCompleted == 100
                    }">check_circle</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-body">
    <h4>Please complete your Program Sections in order</h4>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close()">
      OK
    </button>
  </div>
</ng-template>